/**
 * Disclaimer Page
 */

import { PolicyPage } from './PolicyPage';

const disclaimerContent = `FLOWRITHM – DISCLAIMER
Operated by Lagori AI LLP
Last Updated: [Insert Date]

1. No Broker / No Execution Guarantee
FlowRithm is a technology platform that provides tools, analytics, and features to assist you in research, strategy building, backtesting, portfolio analysis, and monitoring across multiple Indian broker accounts. FlowRithm is not a broker, sub-broker, broker-dealer, exchange, custodian, clearing member, or a SEBI-registered intermediary.

Use of FlowRithm does not itself constitute placing or executing any trades. Actual order placement, execution, and settlement are managed solely by the broker you are connected to.

2. Not Investment Advice / Not Financial Advice
All information, analytics, insights, signals, recommendations, backtest results, or AI-generated outputs provided via FlowRithm are for informational and educational purposes only.

Unless you have separately contracted with a certified financial advisor (using FlowRithm's advisor module), FlowRithm does not provide financial, investment, tax or legal advice.

3. Market Risk, Volatility & No Guarantees
Trading in financial instruments involves substantial risk. Market conditions may change rapidly. Price fluctuations, volatility, liquidity constraints, slippage, margin requirements, regulatory changes, or macro-economic events may lead to partial or total loss of investments.

Past performance, including backtest results or track records, does NOT guarantee future results.

4. AI / Algorithmic / Model Limitations
FlowRithm may utilize algorithmic engines, AI/ML models, and other quantitative tools to deliver analytics, signals, or suggestions. Such outputs are probabilistic, based on historical data, mathematical assumptions, and model parameters.

These outputs may be incorrect, incomplete, or may fail under changing market conditions. FlowRithm does not guarantee profits, accuracy, reliability, or performance of any AI-based signals, strategy suggestions, or analytics.

5. Data Feed, Broker API & System Reliability
FlowRithm integrates with third-party brokers, market data providers, cloud infrastructure, and APIs. We do not guarantee continuous availability, uninterrupted service, error-free data feeds, or zero latency.

6. Limitation of Liability & No Warranty
FlowRithm and Lagori AI LLP make no express or implied warranties of any kind. Under no circumstances shall we be liable for trading losses, missed trades, opportunity losses, or indirect damages.

Maximum liability shall be limited to the subscription fees paid by you to FlowRithm in the twelve (12) months preceding the event.

7. Contact & Support
If you have questions about this Disclaimer:
Lagori AI LLP
Email: contact@flowrithm.trade`;

export function DisclaimerPage() {
  return <PolicyPage title="Disclaimer" content={disclaimerContent} />;
}

